import posthog from 'posthog-js'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_POSTHOG_HOST

// Prod only: every IIS env (beta, beta5, test) ships the production build with the same key
// baked in, so without a hostname gate they all pump noise into the real project.
const isProdHost = /^(?:www\.)?contractfinderpro\.com$/i.test(window.location.hostname)

export const isPosthogEnabled = Boolean(posthogKey && posthogHost) && isProdHost

if (!isPosthogEnabled) {
  if (import.meta.env.DEV) {
    const variableName = !posthogKey ? 'VITE_POSTHOG_KEY' : 'VITE_POSTHOG_HOST'
    console.warn(
      `[posthog] disabled: ${variableName} not set. No events will be captured in this environment. Set it to enable PostHog.`,
    )
  }
} else {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2026-05-30',
    logs: {
      serviceName: 'cfp-public-web',
      environment: import.meta.env.MODE,
    },
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
  })
}

export const posthogLogger = {
  info(message: string, attributes: Record<string, string | number | boolean>) {
    if (isPosthogEnabled) {
      posthog.logger.info(message, attributes)
    }
  },
}

export default posthog
